/* tslint:disable */
/* eslint-disable */
/**
 * Sunshine Auction API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    AdminOrderMarketplace,
    AdminOrderMarketplaceFromJSON,
    AdminOrderMarketplaceFromJSONTyped,
    AdminOrderMarketplaceToJSON,
} from './AdminOrderMarketplace';
import {
    AdminOrderPaymentType,
    AdminOrderPaymentTypeFromJSON,
    AdminOrderPaymentTypeFromJSONTyped,
    AdminOrderPaymentTypeToJSON,
} from './AdminOrderPaymentType';
import {
    AdminOrderStatus,
    AdminOrderStatusFromJSON,
    AdminOrderStatusFromJSONTyped,
    AdminOrderStatusToJSON,
} from './AdminOrderStatus';
import {
    AdminOrderType,
    AdminOrderTypeFromJSON,
    AdminOrderTypeFromJSONTyped,
    AdminOrderTypeToJSON,
} from './AdminOrderType';

/**
 * 
 * @export
 * @interface AdminProductOrders
 */
export interface AdminProductOrders {
    /**
     * 
     * @type {string}
     * @memberof AdminProductOrders
     */
    createdAt: string;
    /**
     * 
     * @type {string}
     * @memberof AdminProductOrders
     */
    id: string;
    /**
     * 
     * @type {AdminOrderMarketplace}
     * @memberof AdminProductOrders
     */
    marketplace?: AdminOrderMarketplace;
    /**
     * 
     * @type {AdminOrderType}
     * @memberof AdminProductOrders
     */
    orderType: AdminOrderType;
    /**
     * 
     * @type {AdminOrderPaymentType}
     * @memberof AdminProductOrders
     */
    paymentType: AdminOrderPaymentType;
    /**
     * 
     * @type {number}
     * @memberof AdminProductOrders
     */
    salePrice: number;
    /**
     * 
     * @type {Array<AdminOrderStatus>}
     * @memberof AdminProductOrders
     */
    statuses: Array<AdminOrderStatus>;
}



export function AdminProductOrdersFromJSON(json: any): AdminProductOrders {
    return AdminProductOrdersFromJSONTyped(json, false);
}

export function AdminProductOrdersFromJSONTyped(json: any, ignoreDiscriminator: boolean): AdminProductOrders {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'createdAt': json['createdAt'],
        'id': json['id'],
        'marketplace': !exists(json, 'marketplace') ? undefined : AdminOrderMarketplaceFromJSON(json['marketplace']),
        'orderType': AdminOrderTypeFromJSON(json['orderType']),
        'paymentType': AdminOrderPaymentTypeFromJSON(json['paymentType']),
        'salePrice': json['salePrice'],
        'statuses': ((json['statuses'] as Array<any>).map(AdminOrderStatusFromJSON)),
    };
}

export function AdminProductOrdersToJSON(value?: AdminProductOrders | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'createdAt': value.createdAt,
        'id': value.id,
        'marketplace': AdminOrderMarketplaceToJSON(value.marketplace),
        'orderType': AdminOrderTypeToJSON(value.orderType),
        'paymentType': AdminOrderPaymentTypeToJSON(value.paymentType),
        'salePrice': value.salePrice,
        'statuses': ((value.statuses as Array<any>).map(AdminOrderStatusToJSON)),
    };
}

